import { render } from "./Autoregister.vue?vue&type=template&id=97b043e8&scoped=true"
import script from "./Autoregister.vue?vue&type=script&lang=js"
export * from "./Autoregister.vue?vue&type=script&lang=js"

import "./Autoregister.vue?vue&type=style&index=0&id=97b043e8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b043e8"]])

export default __exports__